import { CanGoOutAloneConditionInput } from '../../lib/types/models/can-go-out-alone-condition/can-go-out-alone-condition'
import { CanGoOutAloneCondition } from '../../lib/types/models/can-go-out-alone-condition/can-go-out-alone-condition'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createCanGoOutAloneCondition(data: CanGoOutAloneConditionInput) {
  return restApiClient
    .url(constructApiUrl(API.canGoOutAloneCondition.create.url, null))
    .post<CanGoOutAloneCondition>(data)
}
